(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessible-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sv-collections]');
    roots.forEach(root => {
      const input = root.querySelector('[data-collection-search]');
      const form = root.querySelector('[data-collection-form]');
      const directory = root.querySelector('#collection-directory');
      const cards = Array.from(root.querySelectorAll('[data-collection-card]'));
      const count = root.querySelector('[data-collection-count]');
      const empty = root.querySelector('[data-collection-empty]');
      if (!input || !cards.length) return;

      const filter = () => {
        const term = input.value.trim().toLowerCase();
        let visible = 0;
        cards.forEach(card => {
          const matches = !term || card.dataset.title.includes(term);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        count.textContent = visible + (visible === 1 ? ' collection found' : ' collections found');
        empty.hidden = visible !== 0;
        root.classList.toggle('is-searching', term.length > 0);
      };

      const showAll = () => {
        input.value = '';
        cards.forEach(card => { card.hidden = false; });
        count.textContent = cards.length + ' collections available';
        empty.hidden = true;
        root.classList.remove('is-searching');
      };

      showAll();
      window.addEventListener('pageshow', showAll);
      input.addEventListener('input', filter);
      input.addEventListener('search', filter);
      form.addEventListener('submit', event => {
        event.preventDefault();
        filter();
        if (input.value.trim() && directory) {
          directory.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const articles = document.querySelectorAll('[data-sv-article]');
    articles.forEach(article => {
      const body = article.querySelector('[data-article-body]');
      const progress = document.querySelector('[data-reading-progress]');
      const copyButton = article.querySelector('[data-copy-link]');
      const copyStatus = article.querySelector('[data-copy-status]');

      const updateProgress = () => {
        if (!body || !progress) return;
        const start = body.getBoundingClientRect().top + window.scrollY;
        const end = start + body.offsetHeight - window.innerHeight;
        const value = end <= start ? 100 : Math.max(0, Math.min(100, ((window.scrollY - start) / (end - start)) * 100));
        progress.style.width = value + '%';
      };

      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();

      copyButton?.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          copyStatus.textContent = 'Link copied';
        } catch {
          copyStatus.textContent = 'Copy unavailable';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["festive-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px) and (min-height: 820px) and (prefers-reduced-motion: no-preference)');

    const initialize = section => {
      if (section.dataset.festiveReady === 'true') return;
      section.dataset.festiveReady = 'true';

      const shell = section.querySelector('[data-festive-scroll-shell]');
      const viewport = section.querySelector('[data-festive-viewport]');
      const track = section.querySelector('[data-festive-track]');
      if (!shell || !viewport || !track) return;

      let distance = 0;
      let frame = 0;

      const update = () => {
        frame = 0;
        if (!desktopQuery.matches || distance <= 0) {
          track.style.setProperty('--festive-track-x', '0px');
          return;
        }

        const start = shell.getBoundingClientRect().top + window.scrollY;
        const range = Math.max(1, shell.offsetHeight - window.innerHeight);
        const progress = Math.min(1, Math.max(0, (window.scrollY - start) / range));
        track.style.setProperty('--festive-track-x', `${Math.round(-distance * progress)}px`);
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      const measure = () => {
        if (!desktopQuery.matches) {
          distance = 0;
          shell.style.removeProperty('--festive-scroll-height');
          track.style.setProperty('--festive-track-x', '0px');
          return;
        }

        distance = Math.max(0, track.scrollWidth - viewport.clientWidth);
        shell.style.setProperty('--festive-scroll-height', `${window.innerHeight + distance + 160}px`);
        update();
      };

      const safeMeasure = () => {
        window.requestAnimationFrame(() => window.requestAnimationFrame(measure));
        window.setTimeout(measure, 160);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', safeMeasure, { passive: true });
      desktopQuery.addEventListener('change', safeMeasure);
      new ResizeObserver(safeMeasure).observe(track);
      track.querySelectorAll('img').forEach(image => {
        if (!image.complete) image.addEventListener('load', safeMeasure, { once: true });
      });
      safeMeasure();
    };

    const initializeAll = root => {
      if (root.matches?.('[data-festive-scroll]')) initialize(root);
      root.querySelectorAll('[data-festive-scroll]').forEach(initialize);
    };
    initializeAll(document);
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-depth-effects"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-home-depth]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  document.body.classList.add('sv-home-depth');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sections = [...document.querySelectorAll('#MainContent > .shopify-section')].filter((item) => !item.contains(root));
  sections.forEach((item) => item.classList.add('sv-depth-reveal'));

  if (reduced || !('IntersectionObserver' in window)) {
    sections.forEach((item) => item.classList.add('sv-depth-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('sv-depth-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: .07 });

  sections.forEach((item) => observer.observe(item));

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const hero = document.querySelector('.max-hero');
  const frame = hero?.querySelector('.max-hero__frame');
  const content = hero?.querySelector('.max-hero__content');
  if (!hero || !frame || !content) return;

  let raf = 0;
  hero.addEventListener('pointermove', (event) => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      const box = hero.getBoundingClientRect();
      const x = (event.clientX - box.left) / box.width - .5;
      const y = (event.clientY - box.top) / box.height - .5;
      frame.style.transform = `translate3d(${x * -10}px,${y * -7}px,0) scale(1.045)`;
      content.style.transform = `translate3d(${x * 8}px,${y * 6}px,24px)`;
      raf = 0;
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-mobile-search-panel"] && !Shopify.designMode) return;
  try {
    
  const addCurrencySearch = () => {
    document.querySelectorAll('.pick_currency.mldcustom .nice-select .list').forEach((list) => {
      if (list.querySelector('.sv-currency-search')) return;

      const searchItem = document.createElement('li');
      searchItem.className = 'sv-currency-search';
      searchItem.setAttribute('role', 'presentation');

      const input = document.createElement('input');
      input.className = 'sv-currency-search__input';
      input.type = 'search';
      input.placeholder = 'Search';
      input.setAttribute('aria-label', 'Search currency');
      input.autocomplete = 'off';

      const clearButton = document.createElement('button');
      clearButton.className = 'sv-currency-search__clear';
      clearButton.type = 'button';
      clearButton.setAttribute('aria-label', 'Clear currency search');
      clearButton.textContent = '×';

      const stopToggle = (event) => event.stopPropagation();
      searchItem.addEventListener('pointerdown', stopToggle);
      searchItem.addEventListener('click', stopToggle);

      input.addEventListener('input', () => {
        const query = input.value.trim().toUpperCase();
        list.querySelectorAll('.option').forEach((option) => {
          option.hidden = query !== '' && !option.dataset.value.toUpperCase().includes(query);
        });
      });

      clearButton.addEventListener('click', () => {
        input.value = '';
        input.dispatchEvent(new Event('input'));
        input.focus();
      });

      searchItem.append(input, clearButton);
      list.prepend(searchItem);
    });
  };

  addCurrencySearch();

  const currencySearchObserver = new MutationObserver(addCurrencySearch);
  currencySearchObserver.observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcycler-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const studios = document.querySelectorAll('[data-uv-studio]');
    if (!studios.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      studios.forEach(studio => studio.querySelectorAll('[data-uv-reveal]').forEach(item => item.classList.add('uv-visible')));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('uv-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    studios.forEach(studio => studio.querySelectorAll('[data-uv-reveal]').forEach(item => observer.observe(item)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishit-marquee"] && !Shopify.designMode) return;
  try {
    
  var marquee = document.querySelector(".wishit-marquee");
  var marqueeWrapper = document.querySelector(".wishit-marquee-wrapper");
  marqueeWrapper.style.height = marquee.offsetHeight + "px";

  } catch(e) { console.error(e); }
})();
})();
